import { motion } from 'framer-motion';
import styles from './QuizProgressBar.module.css';

const QuizProgressBar = ({ progress }) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.topRow}>
        <p className={styles.label}>Progress</p>
        <span className={styles.percentageTop}>{progress}%</span>
      </div>
      <div className={styles.barContainer}>
        <motion.div
          className={styles.barFill}
          initial={{ width: 0 }}
          animate={{ width: `${progress}%` }}
          transition={{ duration: 1, ease: 'easeInOut' }}
        />
      </div>
    </div>
  );
};

export default QuizProgressBar;